module.exports = __webpack_public_path__ + "static/media/magasin.681b9f7c.png";